// extracted by mini-css-extract-plugin
export default {"autocomplete":"Autocomplete_autocomplete__1rl6o","autocomplete-close-icon":"Autocomplete_autocomplete-close-icon__RN+Sm"};